import {DialogWhereIsDatevClientIdState} from './dialog-where-is-datev-client-id.state';


export const dialogWhereIsDatevClientIdStateInitial: DialogWhereIsDatevClientIdState = {
  isOpen: false,
};
